module.exports = "/static/assets/1319094a51748798730f01d1dc0972ac.svg";